import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SERVER_URL } from "../../constant";
import axios from "axios";
import AccrodianBox from "../../component/AccrodianBox";
import ButtonCompo from "../../component/ButtonCompo";
import DialogBox from "../../component/DialogBox";
import InputField from "../../component/InputField";
import AlertBox from "../../component/AlertBox";
import { LinearProgress } from "@mui/material";
import SelectField from "../../component/SelectField";
import { FaRegEye } from "react-icons/fa";
import { MdOutlineRefresh } from "react-icons/md";
import { MuiOtpInput } from "mui-one-time-password-input";
import SwitchCompo from "../../component/SwitchCompo";

function SingleEmployee() {
  const { userId } = useParams();
  const [employeeData, setEmployeeData] = useState();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [leaveAccount, setLeaveAccount] = useState([]);
  const [selectedAvailable, setSelectedAvailable] = useState(0);
  const [isEnable, setIsEnable] = useState(true);
  const [reload, setReload] = useState(false);
  const [companySalaryStructure, setCompanySalaryStructure] = useState([]);
  const [userSalaryStructure, setUserSalaryStructure] = useState([]);
  const [enableAddSalaryStructureForm, setEnableAddSalaryStructureForm] =
    useState(false);
  const [selectedCtc, setSelectedCtc] = useState(0);
  const [selectedBasic, setSelectedBasic] = useState(0);
  const [inHand, setInhand] = useState(0);
  const [forgotPwdOtp, setForgotPwdOtp] = useState(undefined);
  const [employeeActiveStatus, setEmployeeActiveStatus] = useState(undefined);
  const [inactiveNote, setInactiveNote] = useState("");
  const [password, setPassword] = useState("");
  const [employeeNameValidation, setEmployeeNameValidation] = useState("");
  const [opsValid, setOpsValid] = useState("");

  async function getEmployee() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/employee/get/${userId}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setEmployeeData(res.data?.data);
      setUserSalaryStructure(res.data?.data?.salaryStructure || []);
      setSelectedCtc(res.data?.data?.ctc || 0);
      setSelectedBasic(res.data?.data?.basic || 0);
      setInhand(res.data?.data?.inHand || 0);
      setEmployeeActiveStatus(res.data?.data?.isActive || false);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  async function getForgotPwdOtp() {
    if (employeeData?.gmail === "" || !employeeData?.gmail) {
      setOpen(true);
      setSuccess(false);
      setMessage("Employee's personal email address not found");
      return null;
    }
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/employee/forgot/password/otp/${employeeData?.gmail}`,
        method: "get",
        withCredentials: true,
      });
      setForgotPwdOtp(res.data?.data || "");
    } catch (error) {
      console.log(error);
      setForgotPwdOtp("");
    } finally {
      setLoading(false);
    }
  }

  async function changeActiveStatus() {
    if (password?.trim() === "") {
      setOpen(true);
      setSuccess(false);
      setMessage("Please enter your password");
      return null;
    }
    if (employeeData?.fullName !== employeeNameValidation) {
      setOpen(true);
      setSuccess(false);
      setMessage("Employee name doesn't match");
      return null;
    }
    if (employeeData?.isActive) {
      if (opsValid !== "Deactive") {
        setOpen(true);
        setSuccess(false);
        setMessage("'Deactive' word doesn't match");
        return null;
      }
    } else {
      if (opsValid !== "Active") {
        setOpen(true);
        setSuccess(false);
        setMessage("'Active' word doesn't match");
        return null;
      }
    }
    const data = {
      status: employeeActiveStatus,
      employeeId: userId,
      password: password,
      note: inactiveNote,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/employee/change/status`,
        method: "post",
        withCredentials: true,
        data: data,
      });
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(true);
      setMessage("Employee status changed");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  }

  async function getLeaveAccount() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/employee/leave/structure/${userId}`,
        method: "get",
        withCredentials: true,
      });
      // console.log(res.data?.data);
      setLeaveAccount(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  //fetch all salary structure
  async function getCompanyStructure() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/salary-structure`,
        method: "get",
        withCredentials: true,
      });
      // console.log(res.data?.data);
      setCompanySalaryStructure(res.data?.data);
      const rawData = res.data?.data;
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Salary structure fetch failed");
    } finally {
      setLoading(false);
    }
  }

  async function editLeave(leaveId, taken) {
    const data = {
      leaveId: leaveId,
      userId: userId,
      value: Number(selectedAvailable) + Number(taken),
      isEnable: isEnable,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/edit/single/employee/leave`,
        method: "post",
        withCredentials: true,
        data: data,
      });
      setOpen(true);
      setSuccess(true);
      setMessage("Leave updated successfully");
      setReload((prev) => !prev);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Leave update failed");
    } finally {
      setLoading(false);
    }
  }

  async function editSalaryStructure(isEdit) {
    // console.log(userSalaryStructure)
    if (selectedBasic === 0 || selectedCtc === 0 || inHand === 0) {
      setOpen(true);
      setSuccess(false);
      setMessage("Basic and CTC and In Hand must be more than 0");
      return null;
    }
    let updatedSalaryStructure;
    if (isEdit) {
      updatedSalaryStructure = userSalaryStructure;
    } else {
      updatedSalaryStructure = companySalaryStructure;
    }
    const data = {
      basic: selectedBasic,
      ctc: selectedCtc,
      salaryStructure: updatedSalaryStructure,
      userId: userId,
      inHand: inHand,
    };
    console.log(data);
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/update/employee/salary/structure`,
        method: "put",
        withCredentials: true,
        data: data,
      });
      setReload((prev) => !prev);
      // if(isEdit === false) {
      //   setEnableAddSalaryStructureForm(false)
      // }
      setOpen(true);
      setSuccess(true);
      setMessage("Salary structure updated successfully");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(
        error?.response?.data?.message || "Salary structure update failed"
      );
    } finally {
      setLoading(false);
    }
  }

  function setData(data) {
    setSelectedAvailable(data?.available);
    setIsEnable(data?.isCustomLeaveEnable);
  }

  const isEnableArray = [
    {
      title: "Yes",
      value: true,
    },
    {
      title: "No",
      value: false,
    },
  ];

  // console.log(userSalaryStructure);

  // update user salary structure value
  const handleChangeSalary = (index, value) => {
    setUserSalaryStructure((prev) => {
      let newArr = [...prev];

      newArr[index] = { ...newArr[index], amount: Number(value) };

      return newArr;
    });
  };

  // update company salary structure value to add in user account
  const handleChangeCompanySalaryStructure = (index, value) => {
    setCompanySalaryStructure((prev) => {
      let newArr = [...prev];

      newArr[index] = { ...newArr[index], amount: Number(value) };

      return newArr;
    });
  };

  useEffect(() => {
    getEmployee();
  }, [userId, reload]);

  useEffect(() => {
    getLeaveAccount();
  }, [reload]);

  useEffect(() => {
    getCompanyStructure();
  }, []);

  useEffect(() => {
    // finding new field
    if (
      Array.isArray(companySalaryStructure) &&
      companySalaryStructure?.length > 0
    ) {
      const titleSet = new Set(userSalaryStructure.map((data) => data?.name));

      const newFields = companySalaryStructure.filter(
        (data) => !titleSet.has(data?.name)
      );
      console.log(newFields);

      setUserSalaryStructure((prev) => {
        return [...prev, ...newFields];
      });
    }
  }, [companySalaryStructure]);

  // console.log(userSalaryStructure)

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[95vw] md:w-[70vw] p-5">
          <section className="flex flex-col justify-center items-center">
            <section className="w-[5rem] h-[5rem]">
              <img
                src={`${SERVER_URL}/api/v1/file/view/${employeeData?.logo}`}
                className="w-full h-full object-contain rounded-full"
                alt=""
              />
            </section>
            <section className="mt-5 text-center">
              <h1 className="text-[18px] text-slate-700 mb-2 font-medium flex justify-center items-center gap-3">
                <div className="flex items-center justify-center">
                  <div
                    className={`${
                      employeeData?.isActive === true
                        ? "bg-green-500"
                        : "bg-red-500"
                    } w-3 h-3 rounded-full`}
                  ></div>
                </div>
                {employeeData?.fullName}{" "}
              </h1>
              <span className="bg-slate-200 text-[15px] px-3 py-1 rounded-full text-slate-700">
                {employeeData?.role}
              </span>
            </section>
          </section>
          <section className="mt-5">
            <AccrodianBox title={"Leave Account"} id={1}>
              <div className="space-y-5">
                {leaveAccount?.map((data, i) => (
                  <section className="grid grid-cols-4 border p-3 rounded-[10px] cursor-pointer hover:bg-slate-100">
                    <section className="space-y-1">
                      <p className="text-[15px] text-slate-500">Title</p>
                      <p>{data?.title}</p>
                    </section>
                    {data?.available !== undefined && (
                      <section className="space-y-1">
                        <p className="text-[15px] text-slate-500">Available</p>
                        <p>{data?.available}</p>
                      </section>
                    )}
                    {data?.taken !== undefined && (
                      <section className="space-y-1">
                        <p className="text-[15px] text-slate-500">Taken</p>
                        <p>{data?.taken}</p>
                      </section>
                    )}
                    <section>
                      {data?.title !== "Unpaid" &&
                      data?.title !== "Comp Off" ? (
                        <DialogBox
                          trigger={
                            <ButtonCompo onClick={() => setData(data)}>
                              Edit
                            </ButtonCompo>
                          }
                          title="Edit Available Leave"
                          actionButton={
                            <ButtonCompo
                              onClick={() =>
                                editLeave(data?.leaveId, data?.taken)
                              }
                            >
                              Save
                            </ButtonCompo>
                          }
                        >
                          <div className="space-y-3">
                            <InputField
                              label="Available"
                              value={selectedAvailable}
                              onChange={(event) =>
                                setSelectedAvailable(
                                  Number(event?.target?.value)
                                )
                              }
                            />
                            <SelectField
                              value={isEnable}
                              valueArray={isEnableArray}
                              setValue={(event) =>
                                setIsEnable(event?.target?.value)
                              }
                              label={"Enable"}
                            />
                          </div>
                        </DialogBox>
                      ) : (
                        ""
                      )}
                    </section>
                  </section>
                ))}
              </div>
            </AccrodianBox>
            <AccrodianBox title="Salary Structure" id={2}>
              <div>
                {enableAddSalaryStructureForm === true ? (
                  <div>
                    <div>
                      <div className="mt-5 w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-10">
                        <InputField
                          label={"CTC"}
                          onChange={(e) => setSelectedCtc(e?.target?.value)}
                          value={selectedCtc}
                        />
                        {companySalaryStructure?.map((e, i) => (
                          <InputField
                            label={e?.name}
                            onChange={(e) =>
                              handleChangeCompanySalaryStructure(
                                i,
                                e?.target?.value
                              )
                            }
                            value={e?.amount}
                            key={i}
                          />
                        ))}
                        <InputField
                          label={"Basic"}
                          onChange={(evt) =>
                            setSelectedBasic(evt?.target?.value)
                          }
                          value={selectedBasic}
                        />
                      </div>
                      <div className="mt-3 flex justify-end">
                        <ButtonCompo
                          variant={"contained"}
                          onClick={() => editSalaryStructure(false)}
                        >
                          Save Changes
                        </ButtonCompo>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    {userSalaryStructure?.length === 0 ? (
                      <div className="flex justify-center items-center gap-3 flex-col pb-3">
                        <p className="text-slate-500 font-medium">
                          No salary structure added yet
                        </p>
                        <ButtonCompo
                          variant={"contained"}
                          onClick={() => setEnableAddSalaryStructureForm(true)}
                        >
                          Add Salary Structure
                        </ButtonCompo>
                      </div>
                    ) : (
                      <div>
                        <div>
                          <h2 className="font-semibold w-fit pl-2 text-slate-700">
                            CTC Fields
                          </h2>
                          <div className="mt-5 w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-10">
                            <InputField
                              label={"CTC"}
                              onChange={(e) => setSelectedCtc(e?.target?.value)}
                              value={selectedCtc}
                            />
                            {userSalaryStructure?.map((e, i) =>
                              e?.isDeduction !== true ? (
                                <InputField
                                  label={e?.name}
                                  onChange={(e) =>
                                    handleChangeSalary(i, e?.target?.value)
                                  }
                                  value={e?.amount}
                                  key={i}
                                />
                              ) : (
                                ""
                              )
                            )}
                            <InputField
                              label={"Basic"}
                              onChange={(evt) =>
                                setSelectedBasic(evt?.target?.value)
                              }
                              value={selectedBasic}
                            />
                            <InputField
                              label={"In Hand"}
                              onChange={(evt) => setInhand(evt?.target?.value)}
                              value={inHand}
                            />
                          </div>
                        </div>
                        <div className="mt-5">
                          <h2 className="font-semibold w-fit text-slate-700">
                            Deduction Fields
                          </h2>
                          <div className="mt-5 w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-10">
                            {userSalaryStructure?.map((e, i) =>
                              e?.isDeduction === true ? (
                                <InputField
                                  label={e?.name}
                                  onChange={(e) =>
                                    handleChangeSalary(i, e?.target?.value)
                                  }
                                  value={e?.amount}
                                  key={i}
                                />
                              ) : (
                                ""
                              )
                            )}
                          </div>
                        </div>
                        <div className="mt-3 flex justify-end">
                          <ButtonCompo
                            variant={"contained"}
                            onClick={() => editSalaryStructure(true)}
                          >
                            Save Changes
                          </ButtonCompo>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </AccrodianBox>
          </section>
          <section className="mt-5">
            <p className="text-[13px] font-medium tracking-wide text-slate-500">
              MORE
            </p>
            <div className="mt-5">
              <AccrodianBox title={"Forgot Password OTP"}>
                <div>
                  <div className="flex flex-col items-center justify-center">
                    <ButtonCompo
                      variant={"contained"}
                      startIcon={<FaRegEye />}
                      onClick={getForgotPwdOtp}
                    >
                      View OTP
                    </ButtonCompo>
                    <section className="mt-5 w-[25rem] pb-[1rem]">
                      {forgotPwdOtp === undefined ? (
                        <div></div>
                      ) : forgotPwdOtp === "" ? (
                        <div>
                          <p>OTP not found</p>
                        </div>
                      ) : (
                        <MuiOtpInput
                          value={forgotPwdOtp}
                          length={6}
                          className="!gap-[5px]"
                          onChange={(value) => setOtp(value)}
                        />
                      )}
                    </section>
                  </div>
                </div>
              </AccrodianBox>
              <AccrodianBox
                title={"Change Employee Status"}
                titleClass={"!text-white !bg-red-500 !border-none"}
                headClass={"!font-bold"}
                iconClass={"!text-white"}
                id={2}
              >
                <div>
                  <section className="flex my-5 justify-between items-center">
                    <p className="text-[17px] font-medium text-slate-700">
                      Employee Status
                    </p>
                    <SwitchCompo
                      value={employeeActiveStatus}
                      setValue={(eve) =>
                        setEmployeeActiveStatus(eve?.target?.checked)
                      }
                    />
                  </section>
                  <section className="grid grid-cols-3 gap-5">
                    <InputField
                      label="Your Password"
                      required
                      onChange={(eve) => setPassword(eve?.target?.value)}
                    />
                    <InputField
                      label="Employee Name"
                      required
                      onChange={(eve) =>
                        setEmployeeNameValidation(eve?.target?.value)
                      }
                    />
                    <InputField
                      label={
                        <p className="">
                          Write{" "}
                          {employeeData?.isActive ? (
                            <span className="text-red-500 font-medium">
                              Deactive
                            </span>
                          ) : (
                            <span className="text-green-500 font-medium">
                              Active
                            </span>
                          )}{" "}
                          for confirmation *
                        </p>
                      }
                      onChange={(eve) => setOpsValid(eve?.target?.value)}
                    />
                  </section>
                  <section className="mt-5">
                    <InputField
                      label="Note"
                      onChange={(eve) => setInactiveNote(eve?.target?.value)}
                    />
                  </section>
                  {employeeData?.isActive === true ? (
                    <section className="mt-5">
                      <p>
                        After being <span>deactive</span>, the employee will not
                        be able to -
                      </p>
                      <ol>
                        <li>1. Login to the account</li>
                        <li>2. Reset the password of the account</li>
                        <li>3. Mark attendance</li>
                        <li>
                          4. Any other operations like leave apply, search
                          employees etc.
                        </li>
                        <li>
                          5. Access to his account even if he/she is already
                          logged in with any system.
                        </li>
                      </ol>
                    </section>
                  ) : (
                    <section className="mt-5">
                      <p>
                        After being <span>active</span>, the employee be able to -
                      </p>
                      <ol>
                        <li>1. Login to the account</li>
                        <li>2. Reset the password of the account</li>
                        <li>3. Mark attendance</li>
                        <li>
                          4. Any other operations like leave apply, search
                          employees etc.
                        </li>
                        <li>
                          5. Access to his account even if he/she is already
                          logged in with any system.
                        </li>
                      </ol>
                    </section>
                  )}
                  <section className="mt-5 flex justify-end">
                    {employeeData?.isActive === true ? (
                      <ButtonCompo
                        onClick={changeActiveStatus}
                        variant={"contained"}
                        color={"error"}
                      >
                        Deactive
                      </ButtonCompo>
                    ) : (
                      <ButtonCompo
                        onClick={changeActiveStatus}
                        variant={"contained"}
                        color={"success"}
                      >
                        Active
                      </ButtonCompo>
                    )}
                  </section>
                </div>
              </AccrodianBox>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default SingleEmployee;
